export const premiumCatalog = [
  "radios/selection",
  "radios/music_hq_premium",
  "premium/music_hq_premium",
  "premium/world_best/music",
  "discover_v2/radios/music",
];

export const isPremium = (permalink: string) => {
  return premiumCatalog.some(
    (premiumCatalogItem) => permalink.indexOf(premiumCatalogItem) >= 0
  );
};
